import SextingCosts from '/src/views/SextingCosts.vue'
import Metrics from '/src/views/Metrics.vue'
import Stexting from '/src/views/Stexting.vue'
import Shifts from '/src/views/Shifts.vue'
import Settings from '/src/views/Settings.vue'
import Login from '/src/views/Login.vue'
import Analytics from '/src/views/Analytics.vue'
import Transactions from '/src/views/Transactions.vue'
import modelsForm from '/src/components/settings/models/modelsForm.vue'
import settingsPanel from '/src/components/settings/settingsPanel.vue'
import groups from '/src/components/settings/groups/groupsSettings.vue'
import employeesForm from '/src/components/settings/employees/employeesForm.vue'
import salary from '/src/components/settings/salary.vue'
import logs from '/src/components/settings/logs.vue'
import login_logs from '/src/components/settings/login_logs.vue'
import message_logs from '/src/components/settings/message_logs.vue'
import privileges from '/src/components/settings/privileges.vue'
import shifts from '/src/components/settings/shifts.vue'
import marketingSetting from "/src/components/settings/marketingSetting.vue"
import companySettings from '/src/components/settings/companySettings.vue'
import moveModels from '/src/components/settings/models/moveModels.vue'
import sessionManagement from '/src/components/settings/sessionManagement.vue'
import taskScheduler from '/src/components/settings/scheduler.vue'
import Tools from '/src/views/Tools.vue'
import Payrolls from '/src/views/Payrolls.vue'
import Verify from '/src/views/Verify.vue'
import Tos from '/src/views/Tos.vue'
import TrackingLinks from '/src/views/TrackingLinks.vue'
import TrialLinks from '@/views/TrialLinks.vue'
import Creators from '/src/views/Creators.vue'
import Employees from '@/views/Employees.vue'
import Profile from '/src/views/Profile.vue'
import NotFound from '/src/views/NotFound.vue'
import ChattingScripts from '/src/views/ChattingScripts.vue'
import Reposting from '/src/views/Features/Reposting.vue'
import Multi_platform from '/src/views/Features/Multi_platform.vue'
import Traffic_tracking from '/src/views/Features/Traffic_tracking.vue'
import ChatterMate from '/src/views/Features/Chattermate.vue'
import EmployeesLanding from '/src/views/Features/Employees.vue'
import Billing from '/src/views/Billing.vue'
import Articles from '@/views/Articles.vue'
import ArticleDetail from '@/views/ArticleDetail.vue'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import AgenciesDashboard from '@/views/admin/Agencies.vue'
import AdminLogin from '@/views/admin/Login.vue'
import CreatorsDashboard from '@/views/admin/Creators.vue'
import EmployeesDashboard from '@/views/admin/Employees.vue'
import Invite from '/src/views/Invite.vue'
import Download from '/src/views/Download.vue'
import Affiliate from '/src/views/Features/Affiliate.vue'
import PrivacyPolicy from '/src/views/PrivacyPolicy.vue'
import Gdpr from '/src/views/Gdpr.vue'
import AddOns from '@/views/AddOns.vue';
import AddOnsManage from '@/views/AddOnsManage.vue';
import newPermissions from '@/components/settings/permissions/newPermissions.vue'
import AdminPermissionSettings from '@/views/admin/Permissions.vue'

const routes = [
    {
        path: '/admin',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { requiresAuth: true, role: 'admin', showLeftMenu: false }
    },
    {
        path: '/admin/permissions',
        name: 'AdminPermissionSettings',
        component: AdminPermissionSettings,
        meta: { requiresAuth: true, role: 'admin', showLeftMenu: false }
    },
    {
        path: '/admin/agencies',
        name: 'AgenciesDashboard',
        component: AgenciesDashboard,
        meta: { requiresAuth: true, role: 'admin', showLeftMenu: false }
    },
    {
        path: '/admin/employees',
        name: 'EmployeesDashboard',
        component: EmployeesDashboard,
        meta: { requiresAuth: true, role: 'admin', showLeftMenu: false }
    },
    {
        path: '/admin/creators',
        name: 'CreatorsDashboard',
        component: CreatorsDashboard,
        meta: { requiresAuth: true, role: 'admin', showLeftMenu: false }
    },
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: { showLeftMenu: false }
    },
    {path: '/download', name: 'Download', component: Download, meta: { showLeftMenu: false }},
    {path: '/privacy', name: 'PrivacyPolicy', component: PrivacyPolicy, meta: { showLeftMenu: false }},
    {path: '/gdpr', name: 'Gdpr', component: Gdpr, meta: { showLeftMenu: false }},
    {path: '/affiliate', name: 'Affiliate', component: Affiliate, meta: { showLeftMenu: false }},
    {path: '/invite', name: 'Invite', component: Invite, meta: { showLeftMenu: false }},
    {path: '/reposting', name: 'Reposting', component: Reposting, meta: { showLeftMenu: false }},
    {path: '/multi_platform', name: 'Multi_platform', component: Multi_platform, meta: { showLeftMenu: false }},
    {path: '/traffic_tracking', name: 'Traffic_tracking', component: Traffic_tracking, meta: { showLeftMenu: false }},
    {path: '/chattermate', name: 'ChatterMate', component: ChatterMate, meta: { showLeftMenu: false }},
    {path: '/employees_shifts', name: 'EmployeesLanding', component: EmployeesLanding, meta: { showLeftMenu: false }},
    {path: '/articles', name: 'ArticlesList', component: Articles, meta: { showLeftMenu: false }},
    {path: '/articles/:articleID', name: 'ArticleDetail', component: ArticleDetail, meta: { showLeftMenu: false }},
    {path: '/', name: 'Login', component: Login, meta: { showLeftMenu: false }},
    {path: '/verify', name: 'Verify', component: Verify, meta: { showLeftMenu: false }},
    {path: '/tos', name: 'Tos', component: Tos, meta: { showLeftMenu: false }},
    {path: '/not_found', name: 'NotFound', component: NotFound, meta: { showLeftMenu: false }},
    { path: '/:pathMatch(.*)*', redirect: { name: 'NotFound' }, meta: { showLeftMenu: false }},
    //from here these are components before the login
    {path: '/billing', name: 'Billing', component: Billing, meta: { showLeftMenu: true }},
    {path: '/sextingcosts', name: 'SextingCosts', component: SextingCosts, meta: { showLeftMenu: true }},
    {path: '/payrolls', name: 'Payrolls', component: Payrolls, meta: { showLeftMenu: true }},
    {path: '/tools', name: 'Tools', component: Tools, meta: { showLeftMenu: true }},
    {path: '/metrics', name: 'Metrics', component: Metrics, meta: { showLeftMenu: true }},
    {path: '/analytics', name: 'Analytics', component: Analytics, meta: { showLeftMenu: true }},
    {path: '/sexting', name: 'Stexting', component: Stexting, meta: { showLeftMenu: true }},
    {path: '/shifts', name: 'Shifts', component: Shifts, props:true, meta: { showLeftMenu: true }},
    {path: '/transactions', name: 'Transactions', component: Transactions, meta: { showLeftMenu: true }},
    {path: '/creators', name: 'Creators', component: Creators, meta: { showLeftMenu: true }},
    {path: '/profile', name: 'Profile', component: Profile, meta: { showLeftMenu: true }},
    {path: '/trackingLinks', name: 'TrackingLinks', component: TrackingLinks, meta: { showLeftMenu: true }},
    {path: '/trialLinks', name: 'TrialLinks', component: TrialLinks, meta: { showLeftMenu: true }},
    {path: '/addons', name: 'AddOns', component: AddOns, meta: { showLeftMenu: true }},
    {path: '/addons/:creatorId', name: 'AddOnsManage', component: AddOnsManage, meta: { showLeftMenu: true }},
    {path: '/employees', name: 'Employees', component: Employees, meta: { showLeftMenu: true }},
    {path: '/chattingScripts', name: 'ChattingScripts', component: ChattingScripts, meta: { showLeftMenu: true }},
    {path: '/settings', name: 'Settings', component: Settings, meta: { showLeftMenu: true },
        children: [
            {
                path: '',
                name: 'settingsPanel',
                component: settingsPanel
            },
            {
                name: 'permissions',
                path: 'permissions',
                component: newPermissions
            },
            {
                name: 'menu',
                path: 'menu',
                component: settingsPanel
            },
            {   
                name: 'settingsGroups',
                path: 'groups',
                component: groups
            },
            {
                name: 'taskScheduler',
                path: 'taskScheduler',
                component: taskScheduler
            },
            {
                name: 'sessionManagement',
                path: 'sessionManagement',
                component: sessionManagement
            },
            {
                name: 'marketingSetting',
                path:'marketingSetting',
                component: marketingSetting
            },
            {
                name: 'moveModels',
                path:'moveModels',
                component: moveModels
            },
            {
                name: 'salary',
                path:'salary',
                component: salary
            },
            {
                name:'employeesForm',
                path:'employees_form',
                component: employeesForm,
                props:true
            },
            {
                name:'modelsForm',
                path:'models/form',
                component: modelsForm,
                props:true
            },
            {
                name: 'logs',
                path:'logs',
                component: logs
            },
            {
                name: 'login_logs',
                path:'login_logs',
                component: login_logs
            },
            {
                name: 'chat_logs',
                path:'chat_logs',
                component: message_logs
            },
            {
                name: 'shifts',
                path:'shifts',
                component: shifts,
                props:true,
            },
            {
                name:'companySettings',
                path:'companySettings',
                component: companySettings
            },
            {
                name: 'privileges', 
                path:'privileges',
                component: privileges,
                props:true
            }
        ]
    }
];

export default routes;
